import * as React from 'react'
import styled, { AnyStyledComponent } from 'styled-components'
import { COLORS } from '../../static/constants'
import FormItem from './_layouts/FormItem'

interface IProps {
  name: string
  options: any[]
  defaultValue?: string
  initialText?: string
  label?: null | string
  error?: null | string
  required?: boolean
  selectRef?: any
  width?: null | number
  onChangeHandler?(event): any
  onBlurHandler?(event): any
}

const Select: React.FC<IProps> = ({
  name,
  options,
  defaultValue,
  initialText,
  label,
  error,
  required,
  selectRef,
  onChangeHandler,
  onBlurHandler,
  width,
}) => {
  return (
    <FormItem label={label} required={required} error={error}>
      <S.Select
        id={name}
        name={name}
        required={required ? true : false}
        defaultValue={defaultValue}
        initialText={initialText}
        width={width}
        ref={selectRef || null}
        onChange={event => {
          if (typeof onChangeHandler === 'function') {
            onChangeHandler(event)
          }
        }}
        onBlur={event => {
          if (typeof onBlurHandler === 'function') {
            onBlurHandler(event)
          }
        }}
      >
        {initialText && <option value="">{initialText}</option>}
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </S.Select>
    </FormItem>
  )
}

const S: { [key: string]: AnyStyledComponent } = {}

S.Select = styled.select<{ width?: number }>`
  appearance: none;
  margin: 0;
  padding: 0;
  background: none transparent;
  vertical-align: middle;
  font-size: inherit;
  color: inherit;
  outline: none;

  width: ${({ width }) => (width ? `${width}px` : '100%')};
  border: solid 1px ${COLORS.Border};
  border-radius: 4px;
  padding: 8px 12px;
`

export default Select
